"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentTag = exports.ShipmentPurchaseSource = void 0;
// Explicitly redefining this here in case this ever differs in the future.
var ShipmentPurchaseSource;
(function (ShipmentPurchaseSource) {
    ShipmentPurchaseSource["MultipleShipment"] = "multipleShipment";
    ShipmentPurchaseSource["PartnerShipment"] = "partnerShipment";
    ShipmentPurchaseSource["SingleShipment"] = "singleShipment";
    ShipmentPurchaseSource["FlexibleFleet"] = "flexibleFleet";
    ShipmentPurchaseSource["RecurringOrder"] = "recurringOrder";
})(ShipmentPurchaseSource = exports.ShipmentPurchaseSource || (exports.ShipmentPurchaseSource = {}));
var ShipmentTag;
(function (ShipmentTag) {
    ShipmentTag["Claim"] = "claim";
    ShipmentTag["Damage"] = "damage";
    ShipmentTag["Dispute"] = "dispute";
    ShipmentTag["Lost"] = "lost";
    ShipmentTag["Refused"] = "refused";
    ShipmentTag["Returned"] = "returned";
    ShipmentTag["Issue"] = "issue";
    ShipmentTag["FRTUpdated"] = "frtupdated";
})(ShipmentTag = exports.ShipmentTag || (exports.ShipmentTag = {}));
//# sourceMappingURL=shipmentMetadata.js.map